import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Voter } from 'src/app/models/Voter';
import { Round } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-import-table',
  templateUrl: 'import-table.component.html',
  styleUrls: ['./import-table.component.less', '../../../../shared/common.less'],
})

export class ImportTableComponent implements OnInit {
  @Input() round: Round;
  @Input() selectedRound: boolean = true;
  @Input() voters: Array<Voter> = [];
  @Input() selectedVoters: Array<Voter> = [];
  @Input() filteredVoters: Array<Voter> = [];
  @Input() editionMode: boolean = true;
  @Output() selectedVotersChange = new EventEmitter<Array<Voter>>();
  @Output() voterEdited = new EventEmitter<void>();
  isVotersValid = false;
  editingIndex: number = -1;
  editingVoter: Partial<Voter> = {};

  constructor() { }

  startEdit(index: number) {
    this.editingIndex = index;
    this.editingVoter = { ...this.filteredVoters[index] };
  }

  selectionChangedEvent(newSelection: Array<Voter>) {
    this.selectedVoters = newSelection;
    this.selectedVotersChange.emit(newSelection);
  }

  cancelEdit() {
    this.editingIndex = -1;
    this.editingVoter = {};
  }

  validateEdit(index: number) {
    Object.assign(this.filteredVoters[index], this.editingVoter);
    this.editingIndex = -1;
    this.editingVoter = {};
    this.voterEdited.emit();
  }

  editLastNameAtIndex(index: number, value: string) {
    this.editingVoter = { ...this.editingVoter, lastName: value };
  }

  editFirstNameAtIndex(index: number, value: string) {
    this.editingVoter = { ...this.editingVoter, firstName: value };
  }

  editCollegeAtIndex(index: number, value: string) {
    this.editingVoter = { ...this.editingVoter, college: value };
  }

  editEmailAtIndex(index: number, value: string) {
    this.editingVoter = { ...this.editingVoter, email: value };
  }

  editPhoneAtIndex(index: number, value: string) {
    this.editingVoter = { ...this.editingVoter, phone: value };
  }

  editValidationCodeAtIndex(index: number, value: string) {
    this.editingVoter = { ...this.editingVoter, validationCode: value };
  }

  resetVoters() {
    this.voters = [];
    this.filteredVoters = [];
  }

  ngOnInit(): void {
  }
}
